<template>
  <div class="circle">
    <slot />
  </div>
</template>

<script setup></script>

<style scoped>
.circle {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--neutral-surface-subtle);
  padding: var(--pad-space-sp-8);
  box-shadow: var(--outer-shadow-s-1-x) var(--outer-shadow-s-1-y)
    var(--outer-shadow-s-1-blur) 0 rgba(196, 196, 200, 0.24);
}
</style>
